import { CurrencyPipe, DatePipe } from '@angular/common'
import { Component, HostBinding, Input, OnInit, ViewChild, ChangeDetectorRef, ElementRef, inject, signal } from '@angular/core'
import { Router } from '@angular/router'
import { MatTableDataSource } from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { BehaviorSubject, Subject, combineLatest } from 'rxjs'
import { VetcorPricingTableComponent } from '../vetcor-pricing-table/vetcor-pricing-table.component'
import { map, switchMap, take, tap } from 'rxjs/operators'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { AppPractice, PricingManagerClient, PracticeBatchInfo, PracticesClient, HospitalPrice } from 'src/app/shared/services/ppv.api'
import { VetcorPricingRowService } from '../vetcor-pricing-table/vetcor-pricing-row.service'

@Component({
   selector: 'vetcor-pricing-admin-requests',
   templateUrl: './vetcor-pricing-admin-requests.component.html',
   styleUrls: ['./vetcor-pricing-admin-requests.component.scss'],
   providers: [CurrencyPipe, DatePipe],
   standalone: false,
})
export class VetcorPricingAdminRequestsComponent implements OnInit {
   @ViewChild(VetcorPricingTableComponent) childTable!: VetcorPricingTableComponent

   savedList: boolean = false
   savePDFClicked: boolean = false
   showOnlyUnreviewedProducts: boolean = false

   isCaptain: boolean = true
   loading = true
   practicesLookup$ = new BehaviorSubject<{
      [practiceSKey: number]: AppPractice
   }>(undefined)
   practices: AppPractice[] = []
   refreshBatchStats$ = new Subject<void>()

   adminDashboard: number = 1
   selectedCategory = ''
   products: any[] = []
   dataSource: MatTableDataSource<PricingManagerClient> = new MatTableDataSource()
   @ViewChild(MatSort) sort!: MatSort

   public totalSuggestedPrice: any
   public practiceCompletion: number = 0
   public codesPendingWriteback: number = 0
   public codesRequestedReview: number = 0
   public practiceCompletionAdmin: number = 0

   //settingsForPractice: PracticeBatchInfo[] = [];
   settingsForPractice: any = null

   selectedPricingPartner: number | null = null

   practicesApi = inject(PracticesClient)
   dashboardStats: any = {}
   upcomingPractices: any[] = []
   writebackSuccessPractices: any[] = []
   allPractices: any[] = []
   allPracticesForExport: PracticeBatchInfo[] = []
   isLoadingForReview = true
   isLoadingCompleted = true

   filteredPractices: any[] = []
   practiceSearchTerm: string = ''

   changeRequests = signal<HospitalPrice[]>(undefined)

   @HostBinding('class.full-flex-height') fullFlexHeight = true

   constructor(
      private authManager: AuthManager,
      private pricingManagerClient: PricingManagerClient,
      private cdr: ChangeDetectorRef,
      private pricingService: VetcorPricingRowService,
      public router: Router
   ) {}

   ngOnInit(): void {
      this.authManager
         .getCurrentUser()
         .pipe(
            take(1),
            tap((user) => {
               var adminRole = user.roles.find((x) => {
                  return x.roleName == 'PricingManagerAdmin'
               })

               this.practices = user.practices.filter((p) => !p.doesNotSync)
               const newLookup = {}
               this.practices.forEach((prac) => {
                  newLookup[prac.id] = prac
               })
               this.practicesLookup$.next(newLookup)
            })
         )
         .subscribe()

      this.pricingManagerClient
         .getPricingRequestsForReview()
         .pipe(
            tap((data) => {
               console.log(data)
               const pendingCodes = data?.filter(
                  (item) =>
                     (item.newCodeRequestId || item.pricingChangeRequestId) &&
                     ((!!item.newCodeRequest && !item.newCodeRequest?.isApproved) ||
                        (!!item.pricingChangeRequest && !item.pricingChangeRequest?.captainApproved))
               )
               this.changeRequests.set(data)
               this.dashboardStats = {
                  pending: pendingCodes.length,
                  pendingOver7Days: pendingCodes.filter((item) => {
                     const requestDate = new Date(item.newCodeRequest?.requestedOn || item.pricingChangeRequest?.requestedOn)
                     const currentDate = new Date()
                     const diffTime = Math.abs(currentDate.getTime() - requestDate.getTime())
                     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
                     return diffDays > 7
                  }).length,
               }
            })
         )
         .subscribe()
   }

   hideDotsDrop(dropdownElement: HTMLElement): void {
      if (dropdownElement.classList.contains('show')) {
         dropdownElement.classList.remove('show')
      }
   }

   openDetailsModal(): void {
      document.getElementById('detailsModalButton').click()
   }

   resetBatch(settingsForPractice: any): void {
      if (this.selectedPricingPartner !== null) {
         settingsForPractice.pricingCaptainUserId = this.selectedPricingPartner
      }
      this.pricingManagerClient.resetBatch(settingsForPractice).subscribe({
         next: () => {
            console.log('Reset batch info for practice')
         },
         error: (error) => {
            console.error('Error resetting batch:', error)
         },
      })
   }

   scrollUp(): void {
      ;(window as any).scrollTo({ top: 0, behavior: 'smooth' })
   }

   public isHidden: boolean[] = [false]
   toggleVisibility(index: number) {
      this.isHidden[index] = !this.isHidden[index]
   }

   trackByFn(item: any): number {
      return item.practice
   }

   loadMore() {}

   viewRequests() {
      this.router.navigateByUrl('/vetcor-pricing/admin-requests')
   }

   onRecordUpdated(): void {
      this.cdr.detectChanges()
      this.refreshBatchStats$.next()
   }

   onProductListSaved(saved: boolean) {
      this.savedList = saved
   }
}
